import api from './api';

export const categoryService = {
  // Dohvati sve kategorije
  getAllCategories: async () => {
    return await api.get('/service-categories');
  },

  // Dohvati kategoriju po ID-u
  getCategoryById: async (id) => {
    return await api.get(`/service-categories/${id}`);
  },

  // Kreiraj novu kategoriju
  createCategory: async (categoryData) => {
    return await api.post('/service-categories', categoryData);
  },

  // Ažuriraj kategoriju
  updateCategory: async (id, categoryData) => {
    return await api.put(`/service-categories/${id}`, categoryData);
  },

  // Obriši kategoriju
  deleteCategory: async (id) => {
    return await api.delete(`/service-categories/${id}`);
  },

  // Dohvati kategorije po tenant-u
  getCategoriesByTenant: async (tenantId, page = 1, limit = 10) => {
    return await api.get(`/service-categories/tenant/${tenantId}?page=${page}&limit=${limit}`);
  },
};

export default categoryService;
